export default __webpack_public_path__ + "ff924f883bc27b9258a9ece97cab41ca.svg";